
export class PaddleProps {
  constructor(
    public width = 10,
  ) {}
}